<template lang="html">
    <div class="view-status">
        <PageTitle
            text="Suivi de mon audit">
        </PageTitle>

        <ns-loader
            :toLoad="requiredData"
            @dataFetched="onDataFetched"
            @dataError="onDataError"
        >
            <div slot="loader">
                <div class="layout-width padding">
                    <el-card
                        v-loading="true"
                        element-loading-text="Chargement"
                        class="card-loading-audit"
                    >
                    </el-card>

                </div>
            </div>
            <div
                slot="content"
                class="layout-width padding"
            >
                <ul
                    class="status-steps">
                    <li
                        v-for="s in steps"
                        :key="s.status"
                        :class="{ active: stepsCompleted[s.status] }"
                        class="step">

                        <img
                            v-if="stepsCompleted[s.status]"
                            :src="s.completed.img"
                            class="step-image">
                        <img
                            v-else
                            :src="s.pending.img"
                            class="step-image">

                        <div class="step-text">
                            <h2> {{ s.title }}</h2>
                            <p v-if="stepsCompleted[s.status]">
                                {{ s.completed.txt }}
                            </p>
                            <p v-else>
                                {{ s.pending.txt }}
                            </p>
                        </div>
                    </li>
                </ul>
            </div>
        </ns-loader>

    </div>
</template>

<script>
import PageTitle from '@/components/partials/ui/PageTitle';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
export default {
    name: 'Status',
    components: {
        PageTitle,
        NsLoader,
    },
    data () {
        return {
            currentStep: 'SHIPPED',
            steps: [
                {
                    status: 'VALIDATED',
                    title: 'Validation',
                    completed: {
                        txt: 'La liste des moteurs à auditer est validée',
                        img: '/static/images/status-1-a.svg'
                    },
                    pending: {
                        txt: 'La liste des moteurs à auditer est en attente de validation',
                        img: '/static/images/status-1-i.svg'
                    }
                },
                {
                    status: 'PREPARED',
                    title: 'Préparation',
                    completed: {
                        txt: 'Votre kit Motorbox est en cours de préparation',
                        img: '/static/images/status-2-a.svg'
                    },
                    pending: {
                        txt: 'Votre kit Motorbox n\'est pas encore prêt',
                        img: '/static/images/status-2-i.svg'
                    }
                },
                {
                    status: 'SHIPPED',
                    title: 'Livraison',
                    completed: {
                        txt: 'Votre kit Motorbox en cours de livraison',
                        img: '/static/images/status-3-a.svg'
                    },
                    pending: {
                        txt: 'Votre kit Motorbox n\'a pas encore été envoyé',
                        img: '/static/images/status-3-i.svg'
                    }
                },
                {
                    status: 'AUDITED',
                    title: 'Audit',
                    completed: {
                        txt: 'Nous recueillons les mesures de vos Motorbox',
                        img: '/static/images/status-4-a.svg'
                    },
                    pending: {
                        txt: 'Nous n\'avons pas encore de données de vos moteurs',
                        img: '/static/images/status-4-i.svg'
                    }
                },
                {
                    status: 'RECEIVED',
                    title: 'Retour',
                    completed: {
                        txt: 'Nous avons bien reçu le retour de votre kit',
                        img: '/static/images/status-5-a.svg'
                    },
                    pending: {
                        txt: 'Nous n\'avons pas encore reçu le retour de votre kit',
                        img: '/static/images/status-5-i.svg'
                    }
                }
            ]
        };
    },
    computed: {
        stepsCompleted () {
            if(this.currentStep === '') return false;
            const si = this.currentStep
                ? this.steps.indexOf(this.steps.find(s => s.status === this.currentStep))
                : 0;
            return this.steps.reduce((status, s, i) => {
                // eslint-disable-next-line
                status[s.status] = i <= si ? true : false;
                return status;
            }, {});
        },

        requiredData (){
            return [
                {
                    model: 'audit',
                    name: 'audit',
                    filters: {
                        user: this.$store.getters.currentUser.uid,
                    }
                }
            ];
        }
    },

    created (){
    },

    methods: {
        onDataFetched (response){
            this.currentStep = response.audit.length > 0 ? response.audit[0].status : '';
        },
        onDataError (error){

        },
    }
};
</script>

<style lang="scss">
@import '../../../assets/styles/variables';
.status-steps {
    display: block;
    list-style: none;
    margin: 20px auto;
    padding: 20px;
    background: white;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    h2 {
        font-weight: bold;
        margin: 0;
        color: #ccc;
        margin-bottom: 5px;
    }
    .active h2 {
        color: $--color-primary;
    }

    p {
        margin: 0;
    }

    .step {
        display: block;
        position: relative;
        padding-bottom: 30px;
        padding-left: 80px;
        min-height: 60px;
        &:last-child {
            padding-bottom: 0;
        }
        &:before,
        &:after {
            content: '';
            display: block;
            position: absolute;
            bottom: 5px;
            left: 30px;
            width: 1px;
            top: 65px;
            background-color: #ccc;
        }
        &.active {
            &:after {
                background-color: $--color-primary;
            }
        }
    }

    .step-image {
        position: absolute;
        width: 60px;
        height: 60px;
        left: 0;
        top: 0;
    }

    @media screen and (min-width: $bp) {
        padding-top: 40px;
        .step {
            display: inline-block;
            width: 20%;
            vertical-align: top;
            padding: 70px 20px 0 0;
            &:before,
            &:after {
                top: 30px;
                left: 70px;
                right: 10px;
                bottom: auto;
                height: 1px;
                width: auto;
            }
            &:last-child {
                &:before,
                &:after {
                    display: none;
                }
            }
        }
    }
}

.view-status{
    .card-loading-audit{

        margin: 20px auto;
        padding: 20px;

        @media screen and (min-width: $bp) {
            height: 211px;
            min-height: unset;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Status/index.vue